import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import {
  KARDEX_PERIODO_INITIAL_VALUES,
  KardexPeriodoInput,
  KardexPeriodoProps,
} from '../../../../base/interfaces'
import { notError, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiKardexPeriodoIniciar } from '../../api/apiKardexPeriodoIniciar'
import { kardexPeriodoIniciarComposeService } from '../../services/kardexPeriodoIniciar'
import {
  KardexPeriodoIniciarValidationSchema,
  KardexPeriodoIniciarValidator,
} from '../../validator/kardexPeriodoIniciar.validator'
import KardexPeriodoForm from '../KardexPeriodoForm'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: KardexPeriodoProps) => void
}

type Props = OwnProps

const KardexPeriodoIniciar: FunctionComponent<Props> = (props) => {
  const { onClose, open, ...other } = props
  const form = useForm<KardexPeriodoInput>({
    defaultValues: {
      ...KARDEX_PERIODO_INITIAL_VALUES,
    },
    resolver: yupResolver<any, any, any>(KardexPeriodoIniciarValidationSchema),
  })

  const onSubmit: SubmitHandler<KardexPeriodoInput> = async (values) => {
    try {
      const validationErrors = await KardexPeriodoIniciarValidator(values)
      if (validationErrors.length > 0) {
        notError(validationErrors.join('<br>'))
        return
      }

      const apiInput = kardexPeriodoIniciarComposeService(values)
      swalLoading()
      const newApiInput: KardexPeriodoInput = {
        codigoDocumentoSector: 1,
        descripcion: apiInput.descripcion,
      }
      const res = await apiKardexPeriodoIniciar(newApiInput)

      if (res) {
        notSuccess('Operaciones iniciadas correctamente')
        onClose(res)
      }
    } catch (error: any) {
      if (error.response?.errors?.[0]?.extensions?.code === 'USER_INPUT_ERROR') {
        notError(error.response.errors[0].message) // Muestra el mensaje de error específico
      } else {
        swalException(error) // Maneja otros errores
      }
    } finally {
      swalClose()
    }
  }

  const onError = (errors: any) => console.log(errors)
  useEffect(() => {
    if (open) {
      form.reset({ ...KARDEX_PERIODO_INITIAL_VALUES })
    }
  }, [open])

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { maxHeight: '80vh' } }}
      maxWidth="xs"
      fullWidth
      open={open}
      {...other}
      aria-hidden={!open} // Ensure aria-hidden is set only when dialog is not open
    >
      <DialogTitle>Iniciar Operaciones</DialogTitle>
      <DialogContent dividers>
        <KardexPeriodoForm form={form} />
      </DialogContent>
      <DialogActions>
        <Button color="error" size="small" onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size="small"
          variant="contained"
          sx={{ mr: 2.1 }}
        >
          Iniciar Operaciones
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default KardexPeriodoIniciar
